/**
 * Created by K-DEVS on 23/08/2017.
 */
export enum LogoutTypes {
    SESSION_EXPIRATION,
    CHECKOUT,
    UNAUTHORIZED
}
